import _crc from "./es6/crc1";
var exports = {};
exports = _crc.default;
export default exports;